const CAMPAIGN_ID = '4'

export { CAMPAIGN_ID }



// WEBPACK FOOTER //
// ./src/modules/campaign.js